import React, { useState, useEffect } from "react";
import "./Ottdetails.css";
import { MdModeEdit, MdDelete } from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { useSelector } from "react-redux";

const Ottdetails = () => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permission = useSelector((state) => state.permissions);
  const [ottRows, setOttRows] = useState([]);
  const [ottDetail, setOttDetail] = useState("");
  const [ottPrice, setOttPrice] = useState("");
  const [ottIsAdding, setOttIsAdding] = useState(false);
  const [editingOttRowId, setEditingOttRowId] = useState(null);
  const [editOttValue, setEditOttValue] = useState("");
  const [editOttPrice, setEditOttPrice] = useState("");
  const [addButtonEnableOtt, setAddButtonEnableOtt] = useState(true);

  useEffect(() => {
    axios
      .post(apiUrl + "viewott", {})
      .then((res) => {
        setOttRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  }, [apiUrl]);

  // const formatPrice = (price) => {
  //   if (!price) return "";
  //   const number = parseFloat(price.replace(/[^0-9.]/g, ""));
  //   if (isNaN(number)) return "";
  //   return new Intl.NumberFormat("en-IN", {
  //     style: "currency",
  //     currency: "INR",
  //   }).format(number);
  // };
  const formatPrice = (price) => {
    if (!price) return "";
    const number = parseFloat(price.replace(/[^0-9.]/g, ""));
    if (isNaN(number)) return "";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(number);
  };

  const handleOttAddRow = () => {
    setOttIsAdding(true);
  };

  const handleOttSubmit = async (e) => {
    e.preventDefault();
    if (!ottDetail.trim() || !ottPrice.trim()) {
      Swal.fire("Warning!", "Please enter OTT Details and Price.", "warning");
      return;
    }
    try {
      const response = await axios.post(apiUrl + "addott", {
        ottDetail,
        ottPrice,
      });

      Swal.fire("Success!", response.data.message, "success");
      setOttRows((prev) => [
        ...prev,
        { _id: response.data.id, ottDetail, ottPrice },
      ]);
      setOttIsAdding(false);
      setOttDetail("");
      setOttPrice("");
    } catch (error) {
      console.error("Error submitting data", error);
      Swal.fire("Error!", "Failed to submit data.", "error");
    }
  };

  const handleOttEdit = (row) => {
    setEditingOttRowId(row._id);
    setEditOttValue(row.ottDetail);
    setEditOttPrice(row.ottPrice);
    setAddButtonEnableOtt(false);
  };

  const handleOttEditSave = async () => {
    if (
      !editOttValue.trim() ||
      !editOttPrice.trim() ||
      ottRows.find(
        (row) =>
          row._id === editingOttRowId &&
          row.ottDetail === editOttValue.trim() &&
          row.ottPrice === editOttPrice.trim()
      )
    ) {
      Swal.fire("No Update Found", "No changes were made.", "info");
      setEditingOttRowId(null);
      return;
    }

    Swal.fire({
      title: "Do you want to save the changes?",
      showCancelButton: true,
      confirmButtonText: "Save",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axios.post(apiUrl + "updateott", {
            ottId: editingOttRowId,
            ottDetail: editOttValue,
            ottPrice: editOttPrice,
          });

          Swal.fire("Saved!", response.data.Message, "success");
          setOttRows((prev) =>
            prev.map((row) =>
              row._id === editingOttRowId
                ? { ...row, ottDetail: editOttValue, ottPrice: editOttPrice }
                : row
            )
          );
          setEditingOttRowId(null);
        } catch (error) {
          console.error("Edit Error:", error);
          Swal.fire("Error!", "Failed to update OTT Details.", "error");
        }
      }
    });
  };

  const handleOttDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "You want to delete this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.post(apiUrl + "deleteott", { _id: id });
        Swal.fire("Deleted!", response.data.Message, "success");
        setOttRows((prev) => prev.filter((row) => row._id !== id));
      } catch (error) {
        console.error("Delete Error:", error);
        Swal.fire("Error!", "Failed to delete OTT Details.", "error");
      }
    }
  };

  const handleOttCancel = () => {
    setOttDetail("");
    setOttPrice("");
    setOttIsAdding(false);
    setAddButtonEnableOtt(true);
  };

  return (
    <>
      <Topbar />
      <div className="container-fluid ">
        <div className="row ">
          <div className="col-md-6 col-sm-12">
            <h3 className="head mt-4">Settings</h3>
          </div>
          <div className="col-md-6 col-sm-12 text-end">
            {!ottIsAdding &&
              addButtonEnableOtt &&
              permission?.Settings?.["Ott Details"]?.Write && (
                <button
                  className="black-btn add-btn mt-4 me-5 mb-2"
                  onClick={handleOttAddRow}
                >
                  Add
                </button>
              )}
          </div>
        </div>
        <div className="row table-ott-res mt-5">
          <div className="table-responsive">
            <table className="table table-border">
              <thead className="table-th">
                <tr className="ott-head">
                  <th className="table-th-content table-head">OTT Details</th>
                  <th className="table-th-content table-head">Price</th>
                  <th className="table-th-content table-head text-center">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {ottIsAdding && (
                  <tr>
                    <td>
                      <input
                        type="text"
                        value={ottDetail}
                        onChange={(e) => setOttDetail(e.target.value)}
                        placeholder="Enter OTT Details"
                        className="form-control"
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={ottPrice}
                        onChange={(e) =>
                          setOttPrice(formatPrice(e.target.value))
                        }
                        placeholder="Enter Price"
                        className="form-control"
                        style={{ width: "7rem" }}
                      />
                    </td>
                    <td className="d-flex justify-content-center">
                      <button
                        className="blue-btn mx-2"
                        onClick={handleOttSubmit}
                      >
                        Submit
                      </button>
                      <button
                        className="black-btn mx-2"
                        onClick={handleOttCancel}
                      >
                        Cancel
                      </button>
                    </td>
                  </tr>
                )}
                {ottRows.map((row) => (
                  <tr key={row._id}>
                    <td>
                      {editingOttRowId === row._id ? (
                        <input
                          type="text"
                          value={editOttValue}
                          onChange={(e) => setEditOttValue(e.target.value)}
                          className="form-control"
                        />
                      ) : (
                        row.ottDetail
                      )}
                    </td>
                    <td>
                      {editingOttRowId === row._id ? (
                        <input
                          type="text"
                          value={editOttPrice}
                          onChange={(e) =>
                            setEditOttPrice(
                              e.target.value.replace(/[^0-9.]/g, "")
                            )
                          }
                          className="form-control"
                        />
                      ) : (
                        formatPrice(row.ottPrice)
                      )}
                    </td>
                    <td>
                      {editingOttRowId === row._id ? (
                        <div className="d-flex justify-content-center">
                          <button
                            className="blue-btn mx-2"
                            onClick={handleOttEditSave}
                          >
                            Save
                          </button>
                          <button
                            className="black-btn mx-2"
                            onClick={() => setEditingOttRowId(null)}
                          >
                            Cancel
                          </button>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center">
                          <MdModeEdit
                            className="edit-icon"
                            onClick={() =>
                              permission?.Settings?.["Ott Details"]?.Write &&
                              handleOttEdit(row)
                            }
                            style={{
                              cursor: permission?.Settings?.["Ott Details"]
                                ?.Write
                                ? "pointer"
                                : "not-allowed",
                              opacity: permission?.Settings?.["Ott Details"]
                                ?.Write
                                ? 1
                                : 0.5,
                            }}
                            title={
                              permission?.Settings?.["Ott Details"]?.Write
                                ? "Edit"
                                : "No permission to edit"
                            }
                          />

                          <MdDelete
                            className="delete-icon"
                            onClick={() =>
                              permission?.Settings?.["Ott Details"]?.Delete &&
                              handleOttDelete(row._id)
                            }
                            style={{
                              cursor: permission?.Settings?.["Ott Details"]
                                ?.Delete
                                ? "pointer"
                                : "not-allowed",
                              opacity: permission?.Settings?.["Ott Details"]
                                ?.Delete
                                ? 1
                                : 0.5,
                            }}
                            title={
                              permission.Settings?.["Ott Details"]?.Delete
                                ? "Delete"
                                : "No permission to delete"
                            }
                          />
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default Ottdetails;
